import React from 'react';
import {
  Breakpoints,
  TextAppearance,
  TextLineHeight,
  TextSize,
  TextTag,
  TextWeight,
} from '@vw-marketing/us-components';
import { Box, TextBox } from '../../Box';
import { CTAButton } from '../../Button/CTAButton';

interface ContentHeaderProps {
  onBack: () => void;
}

export const ContentHeader = ({ onBack }: ContentHeaderProps) => {
  return (
    <Box>
      <CTAButton
        tag='button'
        emphasis='tertiary'
        aria-label='Open Guide CTA'
        onClick={onBack}
      >
        <TextBox
          appearance={TextAppearance.copy200}
          tag={TextTag.span}
          style={{
            [Breakpoints.default]: {
              fontSize: TextSize.TextSize16,
              fontWeight: TextWeight.regular,
              lineHeight: TextLineHeight.TextLineHeight24,
            },
            [Breakpoints.b1280]: {
              fontSize: TextSize.TextSize16,
              fontWeight: TextWeight.regular,
              lineHeight: TextLineHeight.TextLineHeight24,
            },
          }}
          wrapperStyle={{
            marginTop: '-4px',
          }}
        >
          Open Guide
        </TextBox>
      </CTAButton>
    </Box>
  );
};
